<script>
    import notifier from "../stores/notifier";
    import {fade, fly} from 'svelte/transition';
    import Icon from "./icons/Icon.svelte";
</script>

{#if $notifier.length}
    <div class="notifier">
        {#each $notifier as msg}
            <div class="notifier-msg {msg.type}" in:fly="{{ y: 20, duration: 200 }}" out:fade="{{ duration: 200 }}">
                    <div>
                        {#if msg.type === 'notifier-notice'}
                            <Icon name="check-circle" size="20" strokeWidth="2"/>
                        {:else}
                            <Icon name="alert-triangle" size="20" strokeWidth="2"/>
                        {/if}
                    </div>
                {msg.message}
            </div>
        {/each}
    </div>
{/if}

<style>
    .notifier {
        position: fixed;
        bottom: 10px;
        right: 10px;
        margin: 10px;
        z-index: 9999;
    }

    .notifier .notifier-msg {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        min-width: 300px;
        font-size: 1rem;
        border-radius: 2px;
        padding: 10px 10px;
        margin: 5px;
    }

    .notifier .notifier-notice {
        color: #fff;
        background: #4caf50;
    }

    .notifier .notifier-error {
        color: #fff;
        background: #f44336;
    }
</style>